// LOP - Product card swatches: show all that fit; last slot becomes "+X más" on overflow
(function () {
  'use strict';

  var LIST_SEL = '[data-lop-swatches-overflow-list]';
  var SWATCH_SEL = '.product-swatches-options__item--swatch';
  var OVERFLOW_SEL = '.product-swatches-options__item-overflow-note';
  var HIDDEN_CLASS = 'lop-swatch-overflow-hidden';
  var CONTAINER_SEL = '.product-item__swatches-inline';

  function getMaxWidth(list) {
    var container = list.closest(CONTAINER_SEL) || list.parentElement;
    return container ? container.clientWidth : 0;
  }

  function formatOverflow(list, count) {
    var template = list.getAttribute('data-overflow-template') || '+__COUNT__';
    return template.split('__COUNT__').join(String(count));
  }

  function layoutList(list) {
    var swatches = Array.prototype.slice.call(list.querySelectorAll(SWATCH_SEL));
    var overflow = list.querySelector(OVERFLOW_SEL);
    if (!swatches.length || !overflow) return;

    swatches.forEach(function (swatch) {
      swatch.classList.remove(HIDDEN_CLASS);
      swatch.hidden = false;
    });
    overflow.hidden = true;
    overflow.setAttribute('aria-hidden', 'true');
    overflow.textContent = '';

    var maxWidth = getMaxWidth(list);
    if (maxWidth <= 0) return;

    function fits() {
      return list.scrollWidth <= maxWidth + 1;
    }

    if (fits()) return;

    var hiddenCount = 0;

    while (hiddenCount < swatches.length) {
      var hideIndex = swatches.length - 1 - hiddenCount;
      swatches[hideIndex].classList.add(HIDDEN_CLASS);
      swatches[hideIndex].hidden = true;
      hiddenCount += 1;

      overflow.textContent = formatOverflow(list, hiddenCount);
      overflow.hidden = false;
      overflow.setAttribute('aria-hidden', 'false');

      if (fits() || hiddenCount >= swatches.length) break;
    }
  }

  function layoutAll(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll(LIST_SEL), layoutList);
  }

  window.lopLayoutProductCardSwatches = layoutAll;

  var resizeTimer;

  function scheduleLayout() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      layoutAll();
    }, 50);
  }

  function observeContainers() {
    if (!window.ResizeObserver) return;

    var ro = new ResizeObserver(scheduleLayout);
    Array.prototype.forEach.call(document.querySelectorAll(CONTAINER_SEL), function (el) {
      ro.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      layoutAll();
      observeContainers();
    });
  } else {
    layoutAll();
    observeContainers();
  }

  window.addEventListener('resize', scheduleLayout);
  window.addEventListener('load', scheduleLayout);
  document.addEventListener('shopify:section:load', scheduleLayout);
  document.addEventListener('lop:style-swatches-rendered', function (event) {
    layoutAll(event.detail && event.detail.root ? event.detail.root : document);
  });

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      var needsLayout = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(LIST_SEL)) {
            needsLayout = true;
            return;
          }
          if (node.querySelector && node.querySelector(LIST_SEL)) needsLayout = true;
        });
      });

      if (needsLayout) scheduleLayout();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
